import { isLyrraOne } from '@/lib/platform';
import LearnerManagement from '@/components/institution/LearnerManagement';
import LearnersPage from '@/pages/learners/LearnersPage';

/**
 * LyrraOne formateur : liste via `/eduflows/learners` (achats / assignations).
 * Mode institution classique : gestion RH via `/institution/learners`.
 */
export function FormateurLearnersTabContent() {
  if (isLyrraOne()) {
    return <LearnersPage />;
  }
  return <LearnerManagement />;
}
